import React from 'react'

const VideoCamera = ({
  fill = 'black',
  width
}: {
  fill?: string
  width?: string
}) => (
  <svg
    width={width || '16'}
    height={width || '16'}
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 11.375V7.875C17 7.325 16.55 6.875 16 6.875H4C3.45 6.875 3 7.325 3 7.875V17.875C3 18.425 3.45 18.875 4 18.875H16C16.55 18.875 17 18.425 17 17.875V14.375L21 18.375V7.375L17 11.375Z"
      fill={fill}
    />
  </svg>
)

export default VideoCamera
